export default __webpack_public_path__ + "static/media/spirituality.577c0462.jpg";